module.exports = __webpack_public_path__ + "img/ИФ-1(А)-044-m.d3d7034d.png";